module.exports = __webpack_public_path__ + "img/sable_marin.e9267742.jpg";